export const getW = (value,bool)=>{
    // en %
    switch (value) {
      case 0:
        return "";
      case 1:
        return bool ? "w-[1%]" : "h-[1%]";
      case 2:
        return bool ? "w-[2%]" : "h-[2%]";
      case 3:
        return bool ? "w-[3%]" : "h-[3%]";
      case 4:
        return bool ? "w-[4%]" : "h-[4%]";
      case 5:
        return bool ? "w-[5%]" : "h-[5%]";
      case 6:
        return bool ? "w-[6%]" : "h-[6%]";
      case 7:
        return bool ? "w-[7%]" : "h-[7%]";
      case 8:
        return bool ? "w-[8%]" : "h-[8%]";
      case 9:
        return bool ? "w-[9%]" : "h-[9%]";
      case 10:
        return bool ? "w-[10%]" : "h-[10%]";
      case 11:
        return bool ? "w-[11%]" : "h-[11%]";
      case 12:
        return bool ? "w-[12%]" : "h-[12%]";
      case 13:
        return bool ? "w-[13%]" : "h-[13%]";
      case 14:
        return bool ? "w-[14%]" : "h-[14%]";
      case 15:
        return bool ? "w-[15%]" : "h-[15%]";
      case 16:
        return bool ? "w-[16%]" : "h-[16%]";
      case 17:
        return bool ? "w-[17%]" : "h-[17%]";
      case 18:
        return bool ? "w-[18%]" : "h-[18%]";
      case 19:
        return bool ? "w-[19%]" : "h-[19%]";
      case 20:
        return bool ? "w-[20%]" : "h-[20%]";
      case 21:
        return bool ? "w-[21%]" : "h-[21%]";
      case 22:
        return bool ? "w-[22%]" : "h-[22%]";
      case 23:
        return bool ? "w-[23%]" : "h-[23%]";
      case 24:
        return bool ? "w-[24%]" : "h-[24%]";
      case 25:
        return bool ? "w-[25%]" : "h-[25%]";
      case 26:
        return bool ? "w-[26%]" : "h-[26%]";
      case 27:
        return bool ? "w-[27%]" : "h-[27%]";
      case 28:
        return bool ? "w-[28%]" : "h-[28%]";
      case 29:
        return bool ? "w-[29%]" : "h-[29%]";
      case 30:
        return bool ? "w-[30%]" : "h-[30%]";
      case 31:
        return bool ? "w-[31%]" : "h-[31%]";
      case 32:
        return bool ? "w-[32%]" : "h-[32%]";
      case 33:
        return bool ? "w-[33%]" : "h-[33%]";
      case 34:
        return bool ? "w-[34%]" : "h-[34%]";
      case 35:
        return bool ? "w-[35%]" : "h-[35%]";
      case 36:
        return bool ? "w-[36%]" : "h-[36%]";
      case 37:
        return bool ? "w-[37%]" : "h-[37%]";
      case 38:
        return bool ? "w-[38%]" : "h-[38%]";
      case 39:
        return bool ? "w-[39%]" : "h-[39%]";
      case 40:
        return bool ? "w-[40%]" : "h-[40%]";
      case 41:
        return bool ? "w-[41%]" : "h-[41%]";
      case 42:
        return bool ? "w-[42%]" : "h-[42%]";
      case 43:
        return bool ? "w-[43%]" : "h-[43%]";
      case 44:
        return bool ? "w-[44%]" : "h-[44%]";
      case 45:
        return bool ? "w-[45%]" : "h-[45%]";
      case 46:
        return bool ? "w-[46%]" : "h-[46%]";
      case 47:
        return bool ? "w-[47%]" : "h-[47%]";
      case 48:
        return bool ? "w-[48%]" : "h-[48%]";
      case 49:
        return bool ? "w-[49%]" : "h-[49%]";
      case 50:
        return bool ? "w-[50%]" : "h-[50%]";
      case 51:
        return bool ? "w-[51%]" : "h-[51%]";
      case 52:
        return bool ? "w-[52%]" : "h-[52%]";
      case 53:
        return bool ? "w-[53%]" : "h-[53%]";
      case 54:
        return bool ? "w-[54%]" : "h-[54%]";
      case 55:
        return bool ? "w-[55%]" : "h-[55%]";
      case 56:
        return bool ? "w-[56%]" : "h-[56%]";
      case 57:
        return bool ? "w-[57%]" : "h-[57%]";
      case 58:
        return bool ? "w-[58%]" : "h-[58%]";
      case 59:
        return bool ? "w-[59%]" : "h-[59%]";
      case 60:
        return bool ? "w-[60%]" : "h-[60%]";
      case 61:
        return bool ? "w-[61%]" : "h-[61%]";
      case 62:
        return bool ? "w-[62%]" : "h-[62%]";
      case 63:
        return bool ? "w-[63%]" : "h-[63%]";
      case 64:
        return bool ? "w-[64%]" : "h-[64%]";
      case 65:
        return bool ? "w-[65%]" : "h-[65%]";
      case 66:
        return bool ? "w-[66%]" : "h-[66%]";
      case 67:
        return bool ? "w-[67%]" : "h-[67%]";
      case 68:
        return bool ? "w-[68%]" : "h-[68%]";
      case 69:
        return bool ? "w-[69%]" : "h-[69%]";
      case 70:
        return bool ? "w-[70%]" : "h-[70%]";
      case 71:
        return bool ? "w-[71%]" : "h-[71%]";
      case 72:
        return bool ? "w-[72%]" : "h-[72%]";
      case 73:
        return bool ? "w-[73%]" : "h-[73%]";
      case 74:
        return bool ? "w-[74%]" : "h-[74%]";
      case 75:
        return bool ? "w-[75%]" : "h-[75%]";
      case 76:
        return bool ? "w-[76%]" : "h-[76%]";
      case 77:
        return bool ? "w-[77%]" : "h-[77%]";
      case 78:
        return bool ? "w-[78%]" : "h-[78%]";
      case 79:
        return bool ? "w-[79%]" : "h-[79%]";
      case 80:
        return bool ? "w-[80%]" : "h-[80%]";
      case 81:
        return bool ? "w-[81%]" : "h-[81%]";
      case 82:
        return bool ? "w-[82%]" : "h-[82%]";
      case 83:
        return bool ? "w-[83%]" : "h-[83%]";
      case 84:
        return bool ? "w-[84%]" : "h-[84%]";
      case 85:
        return bool ? "w-[85%]" : "h-[85%]";
      case 86:
        return bool ? "w-[86%]" : "h-[86%]";
      case 87:
        return bool ? "w-[87%]" : "h-[87%]";
      case 88:
        return bool ? "w-[88%]" : "h-[88%]";
      case 89:
        return bool ? "w-[89%]" : "h-[89%]";
      case 90:
        return bool ? "w-[90%]" : "h-[90%]";
      case 91:
        return bool ? "w-[91%]" : "h-[91%]";
      case 92:
        return bool ? "w-[92%]" : "h-[92%]";
      case 93:
        return bool ? "w-[93%]" : "h-[93%]";
      case 94:
        return bool ? "w-[94%]" : "h-[94%]";
      case 95:
        return bool ? "w-[95%]" : "h-[95%]";
      case 96:
        return bool ? "w-[96%]" : "h-[96%]";
      case 97:
        return bool ? "w-[97%]" : "h-[97%]";
      case 98:
        return bool ? "w-[98%]" : "h-[98%]";
      case 99:
        return bool ? "w-[99%]" : "h-[99%]";
      default:
        return bool ? "w-full" : "h-full";
    }
    
}

export function getGrid(n,bool ){
  switch (n) {
    case 1:
      return bool ? 'col-start-1' : 'row-start-1';
    case 2:
      return bool ? 'col-start-2' : 'row-start-2';
    case 3:
      return bool ? 'col-start-3' : 'row-start-3';
    case 4:
      return bool ? 'col-start-4' : 'row-start-4';
    case 5:
      return bool ? 'col-start-5' : 'row-start-5';
    case 6:
      return bool ? 'col-start-6' : 'row-start-6';
    case 7:
      return bool ? 'col-start-7' : 'row-start-7';
    case 8:
      return bool ? 'col-start-8' : 'row-start-8';
    case 9:
      return bool ? 'col-start-9' : 'row-start-9';
    case 10:
      return bool ? 'col-start-10' : 'row-start-10';
    case 11:
      return bool ? 'col-start-11' : 'row-start-11';
    case 12:
      return bool ? 'col-start-12' : 'row-start-12';
    case 13:
      return bool ? 'col-start-13' : 'row-start-13';
    case 14:
      return bool ? 'col-start-14' : 'row-start-14';
    case 15:
      return bool ? 'col-start-15' : 'row-start-15';
    case 16:
      return bool ? 'col-start-16' : 'row-start-16';
    case 17:
      return bool ? 'col-start-17' : 'row-start-17';
    case 18:
      return bool ? 'col-start-18' : 'row-start-18';
    case 19:
      return bool ? 'col-start-19' : 'row-start-19';
    case 20:
      return bool ? 'col-start-20' : 'row-start-20';
    case 21:
      return bool ? 'col-start-21' : 'row-start-21';
    case 22:
      return bool ? 'col-start-22' : 'row-start-22';
    case 23:
      return bool ? 'col-start-23' : 'row-start-23';
    case 24:
      return bool ? 'col-start-24' : 'row-start-24';
    case 25:
      return bool ? 'col-start-25' : 'row-start-25';
    case 26:
      return bool ? 'col-start-26' : 'row-start-26';
    case 27:
      return bool ? 'col-start-27' : 'row-start-27';
    case 28:
      return bool ? 'col-start-28' : 'row-start-28';
    case 29:
      return bool ? 'col-start-29' : 'row-start-29';
    case 30:
      return bool ? 'col-start-30' : 'row-start-30';
    case 31:
      return bool ? 'col-start-31' : 'row-start-31';
    case 32:
      return bool ? 'col-start-32' : 'row-start-32';
    case 33:
      return bool ? 'col-start-33' : 'row-start-33';
    case 34:
      return bool ? 'col-start-34' : 'row-start-34';
    case 35:
      return bool ? 'col-start-35' : 'row-start-35';
    case 36:
      return bool ? 'col-start-36' : 'row-start-36';
    case 37:
      return bool ? 'col-start-37' : 'row-start-37';
    case 38:
      return bool ? 'col-start-38' : 'row-start-38';
    case 39:
      return bool ? 'col-start-39' : 'row-start-39';
    case 40:
      return bool ? 'col-start-40' : 'row-start-40';
    default:
      return '';
  }
  
}

export function getBG(colorName) {
  switch (colorName) {
    case "blue":
      return "bg-blue";
    case "light-blue":
      return "bg-light-blue"
    case "russet":
      return "bg-russet";
    case "cyan":
      return "bg-cyan";
    case "vivid_tangerine":
      return "bg-vivid_tangerine";
    case "white_coffee":
      return "bg-white_coffee";
    case "white":
      return "bg-white";
    case "white2":
      return "bg-white2";
    case "green":
      return "bg-green";
    case "red":
      return "bg-red";
    default:
      return ""; 
  }
}
export function getBorder(colorName) {
  switch (colorName) {
    case "blue":
      return "border-blue";
    case "light-blue":
      return "border-light-blue";
    case "russet":
      return "border-russet";
    case "cyan":
      return "border-cyan";
    case "vivid_tangerine":
      return "border-vivid_tangerine";
    case "white_coffee":
      return "border-white_coffee";
    case "white":
      return "border-white";
    case "white2":
      return "border-white2";
    case "green":
      return "border-green";
    case "red":
      return "border-red";
    default:
      return "";
  }
}
export function getTextColor(colorName) {
  switch (colorName) {
    case "blue":
      return "text-blue";
    case "light-blue":
      return "text-light-blue"
    case "russet":
      return "text-russet";
    case "cyan":
      return "text-cyan";
    case "vivid_tangerine":
      return "text-vivid_tangerine";
    case "white_coffee":
      return "text-white_coffee";
    case "white":
      return "text-white";
    case "white2":
      return "text-white2";
    case "green":
      return "text-green";
    case "red":
      return "text-red";
    default:
      return ""; 
  }
}
export function BG(maincolor,hovercolor){
  return `${getBG(maincolor)} border-4 ${getBorder(maincolor)} hover:${getBorder(hovercolor)}`
}

export function BGTEXT(maincolor,hovercolor,textcolor){
  return `${getBG(maincolor)} border-4 ${getBorder(maincolor)} hover:${getBorder(hovercolor)} ${getTextColor(textcolor)}`
}
